import { createSlide } from "../../slidesOps/createSlide";
import "./index.scss";
export function slideWebsite() {
    const delay = 500;
    const html = `
        <div class="website-container has-light-background">
            <div class="grid">
                <div class="col-3-4">
                    <p class="website__eyebrow text-color text-color--secondary fragment fade-right" data-fragment-index="0" data-autoslide="${delay}">
                        For more information & recordings
                    </p>
                    <h2 class="website__headline text-color">
                        Visit our website
                    </h2>
                    <hr class="website__rule gradient fragment fade-right" data-fragment-index="1" data-autoslide="${delay}" />
                    <p class="website__link text-color fragment fade-right" data-fragment-index="2" data-autoslide="${delay}">
                        <a href="https://www.cedarparkchurchofchrist.org/?cpcref=slidewebsite">
                            www.cedarparkchurchofchrist.org
                        </a>
                    </p>
                </div>
                <div class="col-1-4">
                    <div class="website__qr text-color fragment fade-left" data-fragment-index="3" data-autoslide="${delay}">
                        <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/cedarpark-website-qrcode.svg" />
                    </div>
                </div>
            </div>
        </div>
        <div class="fragment" data-autoslide="15000"></div>
    `;
    createSlide({
        autoslide: 150,
        center: true,
        html: html,
        classList: "video-bg",
        wrap: "false",
        background: {
            color: null,
            video: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/bg-trees.mp4",
            "video-loop": true,
            "video-muted": true,
            size: "cover",
        },
    }, "website");
}
